import type { PrimaryPageAction } from "@octopusdeploy/design-system-components";
import { EmptyStatePlatformHubIllustration, EmptyStateOnboarding } from "@octopusdeploy/design-system-components";
import { OctoLink } from "@octopusdeploy/utilities";
import React, { useEffect } from "react";
import { useAnalyticSimpleActionDispatch } from "~/analytics/Analytics";
import RequestFreeTrialUpsellCallout from "~/components/Callout/RequestFreeTrialUpsellCallout";
export function PlatformHubUpsellPage() {
    const dispatchAction = useAnalyticSimpleActionDispatch();
    const trackOpeningRequestDialog = () => dispatchAction("Request Platform Hub trial dialog opened");
    useEffect(() => {
        dispatchAction("View Platform Hub Upsell page");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const description = (<div>
            <p>In Platform Hub, you can create reusable, standardised blocks of steps for deployment processes or runbooks.</p>
            <p>Ensure that your teams are compliant and secure by default with policies. You can craft and manage deployment rules that can be applied across projects and spaces.</p>
        </div>);
    const platformHubDocsLink = OctoLink.Create("PlatformHub");
    const primaryAction: PrimaryPageAction = {
        type: "custom",
        key: "request-trial",
        content: (<RequestFreeTrialUpsellCallout featureName={"Platform Hub"} onRequestTrial={async (repository) => {
                await repository.PlatformHub.requestTrial();
            }} onTrialRequested={() => dispatchAction("Request for Platform Hub trial submitted")} docsLink={platformHubDocsLink} docsLabel={"Docs: Platform Hub"} dialogTitle={"Request Free Trial of Platform Hub"} trackOpeningRequestDialog={trackOpeningRequestDialog}>
                Platform Hub is only available on Enterprise tier. Contact Sales or request a free trial below.
            </RequestFreeTrialUpsellCallout>),
    };
    return <EmptyStateOnboarding title={"Standardise your deployment processes and enforce policies with Platform Hub"} image={<EmptyStatePlatformHubIllustration />} primaryAction={primaryAction} description={description}/>;
}
